'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _atSigns = require('./atSigns');

var _atSigns2 = _interopRequireDefault(_atSigns);

var _regexSupplant = require('../lib/regexSupplant');

var _regexSupplant2 = _interopRequireDefault(_regexSupplant);

var _spaces = require('./spaces');

var _spaces2 = _interopRequireDefault(_spaces);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validReply = (0, _regexSupplant2.default)(/^(?:#{spaces})*#{atSigns}([a-zA-Z0-9_]{1,20})/, { atSigns: _atSigns2.default, spaces: _spaces2.default }); // Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

exports.default = validReply;
module.exports = exports['default'];